import './App.scss';
import Main from './components/Main.js';
import { initSidebar } from './lib/Sidebar.js';

function App() {
	initSidebar();

	return (
		<div className="App">
			<Main/>
		</div>
	);
}

export default App;
